var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnswers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0a1 1 0 01.117 1.993L14 2H3a1 1 0 00-.993.883L2 3v14a1 1 0 00.883.993L3 18h14a1 1 0 00.993-.883L18 17v-7a1 1 0 011.993-.117L20 10v7a3 3 0 01-2.824 2.995L17 20H3a3 3 0 01-2.995-2.824L0 17V3A3 3 0 012.824.005L3 0h11zm6.707 1.293a1 1 0 01.083 1.32l-.083.094-10 10a1 1 0 01-1.32.083l-.094-.083-3-3a1 1 0 011.32-1.497l.094.083L10 10.585l9.293-9.292a1 1 0 011.414 0z",
    fill: "#596F85",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnswers);
export default __webpack_public_path__ + "static/media/icon-answers.279dadad38b7c17fef1612bd61fb8fbf.svg";
export { ForwardRef as ReactComponent };